import { render, staticRenderFns } from "./GalleryHeader.vue?vue&type=template&id=44f49a91&scoped=true&"
import script from "./GalleryHeader.vue?vue&type=script&lang=js&"
export * from "./GalleryHeader.vue?vue&type=script&lang=js&"
import style0 from "./GalleryHeader.vue?vue&type=style&index=0&id=44f49a91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f49a91",
  null
  
)

export default component.exports